module.exports = __webpack_public_path__ + "static/img/企业文化1.5403e76d.png";